import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { PropsWithChildren } from "react";
import { useState } from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "@/app/store";
import { AdminSessionProvider } from "@/modules/auth/context/AdminSessionProvider";
import { AppLoadingState } from "@/shared/components/AppLoadingState";

export function AppProviders({ children }: PropsWithChildren) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            retry: 1,
            refetchOnWindowFocus: false,
          },
          mutations: {
            retry: false,
          },
        },
      }),
  );

  return (
    <Provider store={store}>
      <PersistGate loading={<AppLoadingState label="Restoring your admin workspace…" />} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <AdminSessionProvider>{children}</AdminSessionProvider>
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  );
}
